import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { IpnDetailsLayout } from '@/areas/components/IpnDetailsPage/IpnDetailsLayout';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// Keeps the side panel across tabs. Pathless, so the offer edit and duplicate pages under `ipn/offers` stay out.
export const Route = createFileRoute('/_authenticated/parts/components/ipn/_details')({
    // The access every tab shares.
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    // A layout's `Route.useSearch` is typed from its own `validateSearch`, not its tabs'.
    // `requiredQuantity` is the quantity the offers tab prices for (`StandardPartPricingTabs`).
    validateSearch: stringSearch({ ipnId: 'required', requiredQuantity: 'optional' }),
    component: RouteComponent,
    // The panel's state belongs to one IPN, a query param; the router would keep it across a query change.
    remountDeps: ({ search }) => search.ipnId,
});

function RouteComponent(): JSX.Element {
    const ipnId = Route.useSearch({ select: (search) => search.ipnId });
    return (
        <IpnDetailsLayout ipnId={ipnId}>
            <Outlet />
        </IpnDetailsLayout>
    );
}
